module.exports = __webpack_public_path__ + "static/img/1.cdf152f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/eng/1.png
// module id = SShE
// module chunks = 0